export default function useAbsoluteLocalePath(): ReturnType<typeof useLocalePath> {
  const localePath = useLocalePath()
  const { origin } = useRequestURL()

  // Absolute URLs are shared outside the visitor's own browsing (link previews, share
  // links, structured data), so they never carry the visitor's ad click IDs (RVZ-28582).
  return (route, locale) => `${origin}${stripClickIds(localePath(route, locale))}`
}
